<template>
  <div class="SaleIndexViewContainer">
    <nut-tabs v-model="tab" type="smile" class="mt12" auto-height>
      <template v-for="(t,ti) in categories" :key="`categories_${ti}`">
        <nut-tabpane :title="t.label" :pane-key="ti" style="padding: 0 16px;height: 88vh">
          <SaleIndexPane :t="t" :ti="ti"/>
        </nut-tabpane>
      </template>
    </nut-tabs>
  </div>
  <nut-tabbar @tab-switch="tabSwitch" style="position: fixed;bottom: 0">
    <nut-tabbar-item tab-title="首页" icon="home"></nut-tabbar-item>
    <nut-tabbar-item tab-title="订单" icon="category"></nut-tabbar-item>
    <nut-tabbar-item tab-title="我的" icon="my"></nut-tabbar-item>
  </nut-tabbar>
</template>

<script>
import api from "@/api";
import {Dialog, } from "@nutui/nutui";
import SaleIndexPane from "@/views/sale/SaleIndexPane.vue";

export default {
  name: "SaleIndexView",
  components: {SaleIndexPane,},
  data() {
    return {
      tab: '0',
      categories: [],
    }
  },
  methods: {
    tabSwitch(item, index){
      if(index == 0){
        this.$router.push('/sale/');
      }else if(index == 1){
        this.$router.push('/sale/agent/order/list');
      }else if(index == 2){
        this.$router.push('/sale/agent/dashboard');
      }
    },

    init() {
      api.getSaleCategory()
          .then(ret => {
            this.categories = ret;
          })
      api.getUserInfo()
          .then(ret => {
            if (ret.phone) {
              return
            }
            Dialog({
              title: '您未绑定手机号',
              content: '为了更好的服务推荐立即绑定手机号',
              cancelText: '下次吧',
              okText: '好的',
              onCancel: () => {

              },
              onOk: () => {
                this.$router.push('/fill/user/info');
              }
            });
          })
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.SaleIndexViewContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 0;
}
</style>